import { Layout } from 'antd';
import { styled } from 'troyfe';
import BaseMenu from '../BaseMenu';
import defaultSettings from '@/defaultSettings';
import { imgUrlHandle } from '@/utils';
import store from '@/store';

const { Sider } = Layout;

const LogoContent = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  background: #44bb55;
  img {
    margin-left: 4px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    color: #ffff;
  }
`;

const SideMenu = (props) => {
  const [appState] = store.useModel('app');
  const { appConfig } = appState;
  return (
    <Sider trigger={null} collapsible collapsed={props.collapsed} width={160} theme={props.theme}>
      <LogoContent>
        {!props.collapsed && <img src={imgUrlHandle(appConfig?.icon?.logo)} alt="logo" />}
        <span style={{whiteSpace:'nowrap'}}>{appConfig?.title}管理后台</span>
      </LogoContent>
      <BaseMenu
        mode="inline"
        theme={props.theme}
        routesData={props.routesData}
        currentCrumbs={props.currentCrumbs}
        setCurrentCrumbs={props.setCurrentCrumbs}
      />
    </Sider>
  );
};

export default SideMenu;
